enum NotificationStatus {
  UNREAD = "UNREAD",
  ARCHIVED = "ARCHIVED",
  DELETED = "DELETED",
}

export default NotificationStatus;
